import React, { JSX } from 'react';
import { useIntl } from 'react-intl';

import ApplicationSelect from './ApplicationSelect';
import { ApplicationSelectorProps } from './ApplicationSelectorContainer';
import LoginFormField from './LoginFormField';
import { loginFormMessages } from './messages';

const ApplicationSelector = ({
  applications,
  value,
  onChange,
}: ApplicationSelectorProps): JSX.Element => {
  const { formatMessage } = useIntl();

  return (
    <LoginFormField label={formatMessage(loginFormMessages.application)}>
      <ApplicationSelect
        applications={applications}
        current={value}
        onChange={onChange}
      />
    </LoginFormField>
  );
};

export default ApplicationSelector;
